import { UserState } from "../../../contexts/userContext";

import {
  VoteSpace,
  getPeriodString,
} from "../../../services/hotColdVoteServices";

import CommonButton from "../../Button";
import CommonPopup from "..";

type Props = {
  popup: string;
  onClose?: () => void;
  onConfirm?: () => void;
  user: UserState;
  voteSpace?: VoteSpace;
};

export default function HotColdVoteEndPopup({
  popup,
  onClose,
  onConfirm,
  user,
  voteSpace,
}: Props) {
  return (
    <CommonPopup isOpen={popup === "voteEnd"} onClose={onClose} padding={0}>
      <div className="flex flex-col gap-2 p-7 leading-[30px]">
        <div className="whitespace-pre-line text-xl font-medium break-keep">
          {`${user.nickname} 님!`}
          {`\n현재 ${user.buildingName ?? ""}`}
          <span className="text-brand-primary-magenta font-semibold">
            {` ${voteSpace?.buildingFloorName ?? ""} ${
              voteSpace?.buildingSpaceName ?? ""
            } `}
          </span>
          {`${getPeriodString(
            voteSpace?.vote?.votePeriod
          )} 투표가 이미 종료되었습니다.`}
        </div>
        <span className="flex text-brand-neutral-60 text-sm">
          * 투표는 하루에 오전 오후 두번만 생성 가능합니다.
        </span>
      </div>
      <CommonButton
        className="rounded-none flex-1 h-bottom-button w-full"
        onClick={onConfirm}
      >
        확인
      </CommonButton>
    </CommonPopup>
  );
}
